import axios from 'axios';
import { getStoredParentStudentId } from '../utilities/teacherModulePermissions';

// Every API call funnels through here, so this is the single place that scopes
// requests to whichever child a parent (user_type 3) account currently has
// selected — callers never need to remember to add student_id themselves, and
// it can't be silently dropped by some file that forgot to thread it through.
function withParentStudentId(params, path = '') {
  const studentId = getStoredParentStudentId();
  if (!studentId) {
    return params;
  }

  // "public/" endpoints are organization-wide config/listings (general
  // settings — which is where the parent handbook URL comes from — CMS
  // pages, blog, public event lists, ...), never scoped to one child.
  // Auto-attaching student_id here doesn't apply, and made the parent
  // handbook button silently stop showing for parent/student accounts:
  // it was reaching general-settings with an unexpected student_id param
  // the backend doesn't handle for that endpoint.
  if (path.startsWith('public/')) {
    return params;
  }

  if (params instanceof FormData) {
    if (!params.has('student_id')) {
      params.append('student_id', studentId);
    }
    return params;
  }

  if (params && typeof params === 'object' && !Array.isArray(params)) {
    if (params.student_id === undefined || params.student_id === null || params.student_id === '') {
      return { ...params, student_id: studentId };
    }
  }

  return params;
}

// Pulls the backend's actual error message out of an apiHandler() result,
// whichever of the shapes it comes back in.
//
// Every auth page reads `res?.response?.data?.data?.message` directly, which
// only exists when apiHandler's catch(e) returned a raw axios error (i.e. the
// request failed with a non-2xx HTTP status - the "Account not found" /
// "Need Admin Approval" style responses this API returns for login failures
// are of this shape). If the backend ever answers with HTTP 200 but an
// embedded failure code instead (the pattern every caller's success check,
// `res.data?.response?.status === 200`, is explicitly guarding against),
// that path resolves to `undefined` and the user sees a blank toast instead
// of whatever the API actually said. Checking every shape means the real
// message always surfaces.
function getApiErrorMessage(res, fallback = "Something went wrong. Please try again.") {
  return (
    res?.response?.data?.data?.message ||
    res?.response?.data?.message ||
    res?.data?.data?.message ||
    res?.data?.response?.message ||
    (typeof res?.message === "string" && res.message) ||
    fallback
  );
}

async function apiHandler(path, method = "GET", params = {}, headers = {}) {
  if (localStorage.getItem("uzoneAuthToken")) {
    //var userData= JSON.parse(localStorage.getItem("uzoneAuthToken"))
    headers = {
      'x-auth-token': `${localStorage.getItem("uzoneAuthToken")}`,
    };
  }
  params = withParentStudentId(params, path);
  let apiRes = null
  const baseURL =
    process.env.REACT_APP_API_BASE_URL ||
    //"https://daycare-api.syntch.ai/";
    "https://api.harmonydaycare.ca/";

  if (!baseURL) {
    return {
      data: {
        response: {
          status: 500,
          message: "Missing REACT_APP_API_BASE_URL in environment",
        },
      },
    };
  }
  switch (method) {
    case "GET":
      try {
        //return await axios.get(`${process.env.API_URL}${path}`, {
        apiRes = await axios.get(`${baseURL}${path}`, {
          headers: headers,
        })
        return apiRes
      }
      catch (e) {
        return e
      }

    case "GET1":
      try {
        //console.log("URL console",process.env.API_URL)
        apiRes = await axios.get(`${baseURL}${path}`, {
          headers: headers,
          params: params
        })
        return apiRes
      }
      catch (e) {
        return e
      }

    case "POST":
      try {
        //console.log("URL console",process.env.API_URL)
        apiRes = await axios.post(`${baseURL}${path}`, params, {
          headers: headers,
        })
        return apiRes
      }
      catch (e) {
        return e
      }

    case "POSTFILE":
      try {
        //console.log("URL console",process.env.API_URL)
        apiRes = await axios.post(`${baseURL}${path}`, params, {
          headers: headers,
        })
        return apiRes
      }
      catch (e) {
        return e
      }

    case "DELETE":
      try {
        //console.log("URL console",process.env.API_URL)
        apiRes = await axios.delete(`${baseURL}${path}`, {
          headers: headers,
          data: params
        })
        return apiRes
      }
      catch (e) {
        return e
      }

    default:
  }

}

export { apiHandler, getApiErrorMessage };